export { default as Card } from '@mui/material/Card'

import { Box, Card } from '@mui/material'

export const IndustrialCard = ({ children, sx = {} }) => {
    return <Card sx={{ flex: 1, marginRight: 1, padding: 1, ...sx }}>
        <Box sx={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'column', flex: 1, height: '100%' }}>
            {children}
        </Box>
    </Card>
}

export default Card;